"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 * @param {*要转为URL参数字符串的对象} param
 * @param {*是否进行URL编码，默认为false} encode
 * @param {*URL参数字符串的前缀} key
 * @description 将对象转为url参数字符串
 */
var urlEncode = function (param, encode, key) {
    if (encode === void 0) { encode = false; }
    if (param == null)
        return '';
    var paramStr = '';
    var t = typeof param;
    if (['string', 'number', 'boolean'].includes(t)) {
        paramStr += "&".concat(key, "=").concat(encode ? encodeURIComponent(param) : param);
    }
    else {
        for (var i in param) {
            var k = key ? key + (param instanceof Array ? '[' + i + ']' : '.' + i) : i;
            paramStr += urlEncode(param[i], encode, k);
        }
    }
    return paramStr;
};
exports.default = urlEncode;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXJsLWVuY29kZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91dGlscy91cmwtZW5jb2RlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUE7Ozs7OztHQU1HO0FBQ0gsSUFBTSxTQUFTLEdBQUcsVUFBQyxLQUFVLEVBQUUsTUFBYyxFQUFFLEdBQW9CO0lBQXBDLHVCQUFBLEVBQUEsY0FBYztJQUMzQyxJQUFJLEtBQUssSUFBSSxJQUFJO1FBQUUsT0FBTyxFQUFFLENBQUE7SUFDNUIsSUFBSSxRQUFRLEdBQUcsRUFBRSxDQUFBO0lBQ2pCLElBQU0sQ0FBQyxHQUFHLE9BQU8sS0FBSyxDQUFBO0lBQ3RCLElBQUksQ0FBQyxRQUFRLEVBQUUsUUFBUSxFQUFFLFNBQVMsQ0FBQyxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsRUFBRTtRQUMvQyxRQUFRLElBQUksV0FBSSxHQUFHLGNBQUksTUFBTSxDQUFDLENBQUMsQ0FBQyxrQkFBa0IsQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFFLENBQUE7S0FDcEU7U0FBTTtRQUNMLEtBQUssSUFBTSxDQUFDLElBQUksS0FBSyxFQUFFO1lBQ3JCLElBQU0sQ0FBQyxHQUFHLEdBQUcsQ0FBQyxDQUFDLENBQUMsR0FBRyxHQUFHLENBQUMsS0FBSyxZQUFZLEtBQUssQ0FBQyxDQUFDLENBQUMsR0FBRyxHQUFHLENBQUMsR0FBRyxHQUFHLENBQUMsQ0FBQyxDQUFDLEdBQUcsR0FBRyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFBO1lBQzVFLFFBQVEsSUFBSSxTQUFTLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxFQUFFLE1BQU0sRUFBRSxDQUFDLENBQUMsQ0FBQTtTQUMzQztLQUNGO0lBRUQsT0FBTyxRQUFRLENBQUE7QUFDakIsQ0FBQyxDQUFBO0FBRUQsa0JBQWUsU0FBUyxDQUFBIn0=